/**
 * Фиксирует html и убирвет скрол
 *
 * @param {boolean} shouldHide спрятать ли скрол
 */

export function hidePageScroll(shouldHide: boolean) {
	document.documentElement.style.overflow = shouldHide ? 'hidden' : 'auto';
}
